import { find } from '@fxts/core';
import { TabType } from '../../../components/cells/Tabs/Tabs';
import { LegacyCateList } from '@services/MarppleShop/features/CateList/type';

export type TabTypeWithDefault = TabType & {
  default?: boolean;
  query: {
    cate_list_id?: number;
  };
};

export class CateListTabsController {
  private current_tab: TabType;

  private readonly items: TabTypeWithDefault[];

  constructor(items: Readonly<TabTypeWithDefault>[]) {
    this.items = structuredClone(items);
    this.current_tab = this.defaultTab;
  }

  public getTabs(): Readonly<TabTypeWithDefault>[] {
    return this.items;
  }

  public getCurrentTabId(): string {
    return this.current_tab.id;
  }

  public setCurrentTabId(id: string): this {
    this.current_tab = this.findTabById(id);
    // 디버깅을 위해 잠시 찍습니당
    console.log(this.current_tab);
    return this;
  }

  private findTabById(id: string): TabTypeWithDefault {
    const matched = find((tab) => tab.id === id, this.items);
    return matched ?? this.defaultTab;
  }

  private get defaultTab(): TabTypeWithDefault {
    const default_tab = find((tab) => tab.default, this.items);
    if (!default_tab) {
      throw new Error('defaultTab is required but was not found');
    }
    return default_tab;
  }

  public static getTabItems(cate_lists: Readonly<LegacyCateList[]>): TabType[] {
    return [
      {
        id: '',
        label: ET('mps2::product::all'),
      },
      ...cate_lists.map(({ id, name }) => ({
        id: `${id}`,
        label: name,
      })),
    ];
  }
}
